import { createContext } from 'react';
import type { InventoryInspectionOutput } from '@/custom-types';

export type InventoryFormMode = 'create' | 'edit';

export type InventoryFormModalContextProps = {
  isOpen: boolean;
  mode: InventoryFormMode;
  propertyId: string | null;
  inventory: InventoryInspectionOutput | null;
  isReadOnly: boolean;
  closeModal: () => void;
  openCreateModal: (propertyId: string) => void;
  openEditModal: (propertyId: string, inventory: InventoryInspectionOutput) => void;
  openDetailsModal: (propertyId: string, inventory: InventoryInspectionOutput) => void;
};

export const InventoryFormModalContext = createContext<InventoryFormModalContextProps | null>(null);

